import React, { useEffect, useState } from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import api from "../../../service";
import { authSuccess } from "../../../redux/modules/auth/actions";
import { changeApplicationLanguage } from "../../../redux/modules/language/actions";
import { useToast } from "../../../hooks/toast";
import { useIntl } from "react-intl";
import { useLoading } from "../../../hooks/loading";
import axios from "axios";

import { clearInitialSettingsState } from "../../../redux/modules/initialSettings/actions";
import { clearChecklist } from "../../../redux/modules/checklist/actions";
import { clearEcommerceInfo } from "../../../redux/modules/ecommerce/actions";
import { clearProfileExhibitor } from "../../../redux/modules/profile/actions";
import { clearProfileServiceProvider } from "../../../redux/modules/profile/actions";
import { clearSystem } from "../../../redux/modules/system/actions";
import { clearEmployee } from "../../../redux/modules/employee/actions";
import { clearAllContractByEvent } from "../../../redux/modules/contract/actions";
import { clearAllEvent } from "../../../redux/modules/event/actions";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ExhibitorOpenID = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const { addToast } = useToast();
  const intl = useIntl();
  const history = useHistory();

  const [code] = useState(query.get("code"));
  const { handleLoading } = useLoading();

  useEffect(() => {
    handleLoading(true);
    api
      .get("/auth/exhibitor-openid-signin", {
        params: {
          code,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((result) => {
        dispatch(
          authSuccess({
            user: result.data.user,
            token: result.data.token,
            customerCenterToken: result.data.customerCenterToken,
            accountCreated: result.data.accountCreated,
            keepSignedIn: true,
            serviceProviderLoggingAsAnExhibitor:
              result.data.serviceProviderLoggingAsAnExhibitor,
          })
        );
        dispatch(
          changeApplicationLanguage({
            code: result.data.user.language,
          })
        );

        dispatch(clearInitialSettingsState());
        dispatch(clearChecklist());
        dispatch(clearEmployee());
        dispatch(clearProfileExhibitor());
        dispatch(clearProfileServiceProvider());
        dispatch(clearEcommerceInfo());
        dispatch(clearAllContractByEvent());
        dispatch(clearAllEvent());
        dispatch(clearSystem());
      })
      .catch((err) => {
        if (err.response.data.code === -2013) {
          addToast({
            type: "info",
            title: intl.formatMessage({
              id: "info",
            }),
            description: intl.formatMessage({
              id: "api.error." + err.response.data.code,
            }),
          });
        } else {
          addToast({
            type: "error",
            title: intl.formatMessage({
              id: "error",
            }),
            description: intl.formatMessage({
              id: "api.error." + err.response.data.code,
            }),
          });
        }
        history.push("/");
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_LOGOUT_URI;
        }, 5000);
      })
      .finally(() => {
        handleLoading(false);
      });
  }, [code, addToast, dispatch, history, intl, handleLoading]);

  return <div style={{ height: "100vh" }}></div>;
};

export default ExhibitorOpenID;
